var _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHasura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-24.5 0 305 305",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ffffff",
    cx: 128,
    cy: 180.374331,
    rx: 103.632079,
    ry: 103.632079
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.254517,211.536972 L130.493847,135.916085 C127.078833,129.25378 118.894399,126.61307 112.213177,130.030607 C105.549611,133.45445 102.908902,141.636361 106.323916,148.301189 L122.508665,179.854765 L93.5403104,208.74241 C88.2248424,214.045267 88.2248424,222.638292 93.5113055,227.951238 C96.1658868,230.604558 99.6426947,231.940046 103.119503,231.940046 C106.59631,231.940046 110.059246,230.604558 112.711305,227.975198 L135.504133,205.232814 L145.08837,223.923336 C147.497039,228.61709 152.236192,231.315809 157.187207,231.315809 C159.262951,231.315809 161.376527,230.832814 163.363995,229.816381 C170.031345,226.400105 172.670793,218.218193 169.254517,211.536972",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.389588,0.926811603 C213.660497,5.83632268 226.714101,50.6129875 195.737781,77.0236005 C176.189903,64.3454431 152.891649,56.9134635 127.843219,56.9134635 C102.871328,56.9134635 79.6355798,64.3175985 60.1170413,76.9109564 C29.3256888,50.4965464 42.3180629,5.83632268 34.6221382,0.926811603 C22.0009749,-7.12281213 -1.72589377,39.1131634 0.0995443512,68.4828991 C1.08306133,84.1872594 5.2607761,107.195767 16.6713589,125.021381 C8.16412841,141.745866 3.26567811,160.553635 3.26567811,180.51822 C3.26567811,248.691952 59.1475563,304.158416 127.844495,304.158416 C196.555465,304.158416 252.424587,248.694483 252.424587,180.51822 C252.424587,160.671341 247.569509,141.958498 239.156675,125.317546 C250.705027,107.44004 254.914633,84.2669962 255.899425,68.4828991 C257.735069,39.1131634 233.994168,-7.12407779 221.389588,0.926811603 M127.843219,276.88462 C74.3085151,276.88462 30.7237882,233.67105 30.7237882,180.516955 C30.7237882,127.388172 74.3085151,84.1568834 127.843219,84.1568834 C181.409814,84.1568834 224.967753,127.388172 224.967753,180.516955 C224.967753,233.673582 181.409814,276.88462 127.843219,276.88462",
    fill: "#628effff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHasura);
export default __webpack_public_path__ + "static/media/icon-hasura.036e4851f99279776ecc2ec39161328e.svg";
export { ForwardRef as ReactComponent };